<template>
  <div class="card selected-log" :class="{floating}" ref="card">
    <div class="card-header" @mousedown.self="onDragStart">
      <img :src="log.user.iconUrl" />
      {{log.user.fullname}}
      <div class="pull-right">
        <button class="btn btn-sm btn-secondary" @click.prevent="float" v-if="!floating">
          <i class="fa fa-expand"></i>
        </button>
        <button class="btn btn-sm btn-secondary" @click.prevent="dock" v-if="floating">
          <i class="fa fa-compress"></i>
        </button>
        <button class="btn btn-sm btn-secondary ml-1" @click.prevent="close">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <div class="card-body">
      <h5 class="card-title">
        <span v-if="log.account">
          {{log.account.name}}
          <br />
        </span>
        <span>{{log.project.title}}</span>
      </h5>
      <small class="pull-right">
        <i class="fa fa-clock-o"></i>
        {{showSelectedUTC ? log.timeSummaryUTC : log.timeSummary}}
        <a
          class="timezone-hour-offset"
          href="#"
          @click.prevent="showSelectedUTC = !showSelectedUTC"
        >({{showSelectedUTC ? 'UTC' : log.timezoneHourOffset }})</a>
        <br />
        <span
          class="pull-right"
        >{{log.hours}} {{log.hours === 1 ? 'hour' : 'hours'}}</span>
      </small>
      <h6>{{log.type}}</h6>
      <p>{{log.details}}</p>
    </div>
  </div>
</template>

<script>
export default {
   props: [
     'log',
     'position',
     'floating',
   ],
  data() {
    return {
      showSelectedUTC: false,
      dragOffset: {
        top: 0,
        left: 0,
      },
    };
  },
  mounted() {
    this.setDefaultCardPosition();
  },
  updated() {
    this.setDefaultCardPosition();
  },
  methods: {
    selectLog(log) {
      this.$emit("select-log", {
        selectedLog: log
      });
    },
    close() {
      this.$emit('close');
    },
    onDragStart(e) {
      if (!this.floating) {
        return;
      }
      this.dragOffset = {
        top: e.layerY,
        left: e.layerX,
      }
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.onDragStop);
    },
    onDrag(e) {
      const top = document.all ? window.event.clientY : e.pageY
      const left = document.all ? window.event.clientX : e.pageX
      this.setCardPosition(top - this.dragOffset.top, left - this.dragOffset.left);
    },
    onDragStop(e) {
      this.$emit('position', {
        top: this.$refs.card.offsetTop,
        left: this.$refs.card.offsetLeft,
      });
      this.resetDragOffset();
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.onDragStop);
    },
    setCardPosition(top, left) {
      this.$refs.card.style.top = top === null ? 'unset' : top + 'px';
      this.$refs.card.style.left = left === null ? 'unset' : left + 'px';
    },
    setDefaultCardPosition() {
      if (!this.floating) {
        this.setCardPosition(null, null);
        return;
      }
      if (this.position && this.position.top && this.position.left) {
        this.setCardPosition(this.position.top, this.position.left);
        return;
      }
      this.setCardPosition(100, 100);
    },
    resetDragOffset() {
      this.dragOffset = {
        top: 0,
        left: 0,
      };
    },
    dock() {
      this.$emit('dock');
    },
    float() {
      this.$emit('float');
    }
  }
};
</script>



// WEBPACK FOOTER //
// assets/js/components/work-logs/SelectedLog.vue